import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomePage from "@/pages/WelcomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardLayout from "@/pages/Dashboard/DashboardLayout";
import HelpPage from "@/pages/HelpPage";
import AdminPage from "@/pages/AdminPage";
import ConfigPreviewPage from "@/pages/ConfigPreviewPage";
import OverviewPreviewPage from "@/pages/OverviewPreviewPage";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<DashboardLayout />} />
        <Route path="/preview/checkin-config" element={<ConfigPreviewPage />} />
        <Route path="/preview/account-overview" element={<OverviewPreviewPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/:section" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
